
import ButtonBlock from 'components/blocks/Button.vue';

export default {
  props: ['data'],
  data() {
    return {
      videoElement: null,
      // imageLoaded: false,
      videoVisible: false,
      mp4: null
    }
  },
  components: {
    ButtonBlock,
  },
  computed: {
    mp4Store() {
      return this.data.mp4;
    },
    // src() {
    //   return this.data.src;
    // }
  },
  methods: {
    play() {
      this.mp4 = this.mp4Store;
      this.videoElement.load();
      this.videoElement.currentTime = 0;
      this.videoElement.play();
    }
  },
  mounted() {
    
    this.videoElement = this.$el.querySelector('.video-video');

    // const image = new Image;
    // image.onload = () => {
    //   this.imageLoaded = true;
    // }
    // image.src = this.src;
  }
}



// WEBPACK FOOTER //
// ./components/mixins/PlayVideo.vue